import React from "react";

export const comoEraHansPublishedAt = (
  <span className="white">
    Revista <i>Vida</i>, No. 28. Compañía Colombiana de Seguros (mayo, 1947)
  </span>
);
